//CHAT INFO
export const CHATINFO_START_CHAT = "CHATINFO_START_CHAT"
export const CHATINFO_FINISH_CHAT = "CHATINFO_FINISH_CHAT"
export const CHATINFO_SAVE_MESSAGE = "CHATINFO_SAVE_MESSAGE"

